import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { get_beneficiary_by_id, update_beneficiary } from '../api/beneficiary_api';
import { isValidPhoneNumber ,isValidPassport} from '../utils/validationId';
import GenericForm from './GenericForm';

const UpdateBeneficiary = () => {
    const { beneficiary_id } = useParams();
    const [beneficiary, setBeneficiary] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            const data = await get_beneficiary_by_id(beneficiary_id);
            setBeneficiary(data);
        };
        fetchData();
    }, [beneficiary_id]);

    if (!beneficiary) return <p>טוען...</p>;

    const handleSubmit = async (data) => {
        const idValue = beneficiary.id; 
        const type = data.id_type || beneficiary.id_type || (/^[A-Za-z]/.test(String(idValue)) ? 'passport' : 'tz');
    
 
        if (type === 'passport') {
            if (!isValidPassport(idValue)) {
                alert("מספר דרכון לא תקין.");
                return;
            }
        }

        const updatedBeneficiary = {
            id: beneficiary.id, 
            id_type: type,
            first_name: data.first_name,
            last_name: data.last_name,
            address: data.address,
            email: data.email,
            phone: data.phone,
            type_case: data.type_case,
            comments: data.comments,
            referring_teacher: data.referring_teacher,
            teacher_phone: data.teacher_phone
        };
    
        if (data.phone && !isValidPhoneNumber(data.phone)) {
            alert("מספר פלאפון לא תקין");
            return;
        }
        if (data.teacher_phone && !isValidPhoneNumber(data.teacher_phone)) {
            alert("מס' פלא' מורה מקשרת לא תקין");
            return;
        }
    
        try {
            await update_beneficiary(updatedBeneficiary);
            alert('עדכון פרטים נקלט בהצלחה!');
            navigate(`/beneficiaries/${updatedBeneficiary.id}`);
        } catch (err) {
            alert('ארעה שגיאה במהלך עדכון פרטים');
            console.error(err);
        }
    };
    

    return (
        <>
           <div className="top-buttons-container">
                {/* כפתור חזרה דף אחורה - עם חץ */}
                <button className="round-nav-btn" onClick={() => navigate(-1)} title="חזרה">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                </button>
                {/* כפתור דף הבית - עם בית */}
                <button className="round-nav-btn" onClick={() => navigate('/main_screen')} title="דף הבית">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2">
                        <path d="M12 3L2 12h3v7h4v-5h6v5h4v-7h3L12 3z" />
                    </svg>
                </button>
            </div>
            <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                <h2 style={{ color: "#150F6B", textAlign: "center" }}>עריכת פרטים</h2>
            </div>
            <GenericForm mode="edit" kind="student" onSubmit={handleSubmit} initialData={beneficiary} />
        </>
    );
};

export default UpdateBeneficiary;
